import type { Consultation } from "./consultations";
import type { LabTest } from "./labTests";

export interface DiagnosticProduct {
  id: number;
  external_id: string;
  slug: string;
  name: string;
  consultation_slug?: string;
  created_at: string;
  updated_at: string;
}

export interface DiagnosticUserProduct {
  id: number;
  diagnostic_user_id: number;
  diagnostic_product_id: number;
  diagnostic_checkout_session_id?: number;
  diagnostic_product: DiagnosticProduct;
  lab_tests: LabTest[];
  consultations: Consultation[];
  created_at: string;
  updated_at: string;
}

export type DiagnosticUserProductsIndexResponse = DiagnosticUserProduct[];
export type DiagnosticUserProductShowResponse = DiagnosticUserProduct;

export const diagnosticUserProductsIndexQuery = () => ({
  url: "/api/v1/diagnostics/diagnostic_user_products",
  method: "GET" as const,
});

export const diagnosticUserProductShowQuery = (id: string | number) => ({
  url: `/api/v1/diagnostics/diagnostic_user_products/${id}`,
  method: "GET" as const,
});
